import { React, useEffect, useState } from "react";
import { Modal, Button, Form, Col, Row, InputGroup } from "react-bootstrap";
import api from "../../services/api";
import { vhostV1 } from "../funcoes";
import { NumericFormat } from "react-number-format";

const ModalSaveItens = ({ show, handleClose, item, onSave }) => {
    const [formData, setFormData] = useState({ ...item });
    const [qtdUnitizada, setQtdUnitizada] = useState(0);
    const [descricao, setDescricao] = useState("");
    const [codProduto, setCodProduto] = useState("");
    const [compra, setCompra] = useState(0);
    const [unidade, setUnidade] = useState("");
    const [ncm, setNcm] = useState(0);
    const [cest, setCest] = useState(0);
    const [cfop, setCfop] = useState(0);
    const [markup, setMarkup] = useState(0);
    const [vendaDefault, setVendaDefault] = useState(0);
    const [precoRealCompra, setPrecoRealCompra] = useState(0);
    const [precoSugerido, setPrecoSugerido] = useState(0);
    const [vlrIncompativel, setValorIncompativel] = useState(false);
    const [textoCstIcms, setTextoCstIcms] = useState("");


    const [precoUnitario, setPrecoUnitario] = useState(0);
    useEffect(
        function () {
            setFormData(item);
        },
        [item]
    );

    let config = {
        headers: {
            Authorization: localStorage.getItem("token"),
        },
    };


    const inputs = document.querySelectorAll("input, select");

    // Adicione um manipulador de eventos para o evento "keydown" em cada entrada ou select
    inputs.forEach(input => {
        input.addEventListener("keydown", e => {
            // Se a tecla pressionada for Enter
            if (e.key === "Enter") {
                e.preventDefault(); // evita que a tecla "Enter" envie um formulário, se aplicável

                // Obtenha o índice do elemento atual
                const currentIndex = Array.from(inputs).indexOf(e.target);

                // Mova o foco para o próximo elemento de entrada ou select
                const nextIndex = currentIndex + 1;
                if (nextIndex < inputs.length) {
                    inputs[nextIndex].focus();
                }
            }
        });
    });

    useEffect(() => {
        if (precoUnitario && qtdUnitizada) {
            setPrecoRealCompra(
                Number(precoUnitario) +
                Number(formData?.IMPOSTOS.ICMS.vICMSST) / Number(qtdUnitizada) +
                Number(formData?.IMPOSTOS.IPI?.IPI.vIPI)
            );
        }
    }, [
        precoUnitario,
        formData?.IMPOSTOS.ICMS.vICMSST,
        formData?.IMPOSTOS.IPI?.IPI.vIPI,
        qtdUnitizada,
    ]);


    useEffect(() => {
        let mk = (Number(precoRealCompra) * Number(markup)) / 100;
        let vendaSugerida = Number(precoRealCompra) + Number(mk);
        setPrecoSugerido(vendaSugerida);
    }, [precoRealCompra, markup]);

    useEffect(() => {
        if (formData?.RELACAO?.QTD_FORNECEDOR && formData?.COMPRA) {
            setPrecoUnitario(
                Number(formData.COMPRA) / Number(formData.RELACAO?.QTD_FORNECEDOR)
            );
        }
    }, [formData.QUANTIDADE_EMBALAGEM, formData?.COMPRA]);

    useEffect(() => {
        if (formData?.QTD && formData?.RELACAO?.QTD_FORNECEDOR) {
            setQtdUnitizada(
                Number(formData.QTD) * Number(formData.RELACAO?.QTD_FORNECEDOR)
            );
        }
    }, [formData?.QTD, formData?.RELACAO?.QTD_FORNECEDOR]);

    // Calculos dos impostos
    //ICMS
    useEffect(() => {
        const baseCalculo = parseFloat(formData?.IMPOSTOS?.ICMS?.vBC);
        const aliquota = parseFloat(formData?.IMPOSTOS?.ICMS?.pICMS);

        if (!isNaN(baseCalculo) && !isNaN(aliquota)) {
            const valorIcms = (baseCalculo * aliquota) / 100;

            setFormData((prev) => ({
                ...prev,
                IMPOSTOS: {
                    ...prev.IMPOSTOS,
                    ICMS: {
                        ...prev.IMPOSTOS?.ICMS,
                        vICMS: valorIcms,
                    },
                },
            }));
        }
    }, [formData?.IMPOSTOS?.ICMS?.vBC, formData?.IMPOSTOS?.ICMS?.pICMS]);

    useEffect(() => {
        const baseCalculo = parseFloat(formData?.IMPOSTOS?.ICMS?.vBCFCP);
        const aliquota = parseFloat(formData?.IMPOSTOS?.ICMS?.pFCP);

        if (!isNaN(baseCalculo) && !isNaN(aliquota)) {
            const valorFCp = (baseCalculo * aliquota) / 100;

            setFormData((prev) => ({
                ...prev,
                IMPOSTOS: {
                    ...prev.IMPOSTOS,
                    ICMS: {
                        ...prev.IMPOSTOS?.ICMS,
                        vFCP: valorFCp,
                    },
                },
            }));
        }
    }, [formData?.IMPOSTOS?.ICMS?.vBCFCP, formData?.IMPOSTOS?.ICMS?.pFCP]);

    // Subst Tributária

    useEffect(() => {
        const baseCalculo = parseFloat(formData?.IMPOSTOS?.ICMS?.vBCST);
        const aliquota = parseFloat(formData?.IMPOSTOS?.ICMS?.pICMSST);

        if (!isNaN(baseCalculo) && !isNaN(aliquota)) {
            const valorIcmsSt = (baseCalculo * aliquota) / 100;

            setFormData((prev) => ({
                ...prev,
                IMPOSTOS: {
                    ...prev.IMPOSTOS,
                    ICMS: {
                        ...prev.IMPOSTOS?.ICMS,
                        vICMSST: valorIcmsSt,
                    },
                },
            }));
        }
    }, [formData?.IMPOSTOS?.ICMS?.vBCST, formData?.IMPOSTOS?.ICMS?.pICMSST]);

    useEffect(() => {
        const baseCalculo = parseFloat(formData?.IMPOSTOS?.ICMS?.vBCFCPST);
        const aliquota = parseFloat(formData?.IMPOSTOS?.ICMS?.pFCPST);

        if (!isNaN(baseCalculo) && !isNaN(aliquota)) {
            const valorFCpST = (baseCalculo * aliquota) / 100;

            setFormData((prev) => ({
                ...prev,
                IMPOSTOS: {
                    ...prev.IMPOSTOS,
                    ICMS: {
                        ...prev.IMPOSTOS?.ICMS,
                        vFCPST: valorFCpST,
                    },
                },
            }));
        }
    }, [formData?.IMPOSTOS?.ICMS?.vBCFCPST, formData?.IMPOSTOS?.ICMS?.pFCPST]);

    // IPI

    useEffect(() => {
        const baseCalculo = parseFloat(formData?.IMPOSTOS?.IPI?.IPI?.vBC);
        const aliquota = parseFloat(formData?.IMPOSTOS?.IPI?.IPI?.pIPI);

        if (!isNaN(baseCalculo) && !isNaN(aliquota)) {
            const valorIPI = (baseCalculo * aliquota) / 100;

            setFormData((prev) => ({
                ...prev,
                IMPOSTOS: {
                    ...prev.IMPOSTOS,
                    IPI: {
                        ...prev.IMPOSTOS?.IPI,
                        IPI: {
                            ...prev.IMPOSTOS?.IPI?.IPI,
                            vIPI: valorIPI,
                        }
                    }
                }
            }));
        }
    }, [formData?.IMPOSTOS?.IPI?.IPI?.vBC, formData?.IMPOSTOS?.IPI?.IPI?.pIPI]);

    // PIS

    useEffect(() => {
        const baseCalculo = parseFloat(formData?.IMPOSTOS?.PIS?.vBC);
        const aliquota = parseFloat(formData?.IMPOSTOS?.PIS?.pPIS);

        if (!isNaN(baseCalculo) && !isNaN(aliquota)) {
            const valorPis = (baseCalculo * aliquota) / 100;

            setFormData((prev) => ({
                ...prev,
                IMPOSTOS: {
                    ...prev.IMPOSTOS,
                    PIS: {
                        ...prev.IMPOSTOS?.PIS,
                        vPIS: valorPis,
                    },
                },
            }));
        }
    }, [formData?.IMPOSTOS?.PIS?.vBC, formData?.IMPOSTOS?.PIS?.pPIS]);

    //COFINS

    useEffect(() => {
        const baseCalculo = parseFloat(formData?.IMPOSTOS?.COFINS?.vBC);
        const aliquota = parseFloat(formData?.IMPOSTOS?.COFINS?.pCOFINS);

        if (!isNaN(baseCalculo) && !isNaN(aliquota)) {
            const valorCofins = (baseCalculo * aliquota) / 100;

            setFormData((prev) => ({
                ...prev,
                IMPOSTOS: {
                    ...prev.IMPOSTOS,
                    COFINS: {
                        ...prev.IMPOSTOS?.COFINS,
                        vCOFINS: valorCofins,
                    },
                },
            }));
        }
    }, [formData?.IMPOSTOS?.COFINS?.vBC, formData?.IMPOSTOS?.COFINS?.pCOFINS]);

    useEffect(
        function(){
            api.post(vhostV1("webcash/produto/Pesquisa/"+item.EAN),
                    {
                        loja: localStorage.getItem("loja"),
                        empresa: 0,
                    },
                    config
                )
                .then(function (response) {
                    if (response && response.data && response.data.dados) {
                        setDescricao(response.data.dados[0].DESCRICAO);
                        setCodProduto(response.data.dados[0].COD_PRODUTO);
                        setCompra(response.data.dados[0].COMPRA);
                        setUnidade(response.data.dados[0].UNIDADE);
                        setNcm(response.data.dados[0].COD_NCM);
                        setCest(response.data.dados[0].CEST);
                        setCfop(response.data.dados[0].CFOP_IN);
                        setMarkup(response.data.dados[0].MARKUP);
                        setVendaDefault(response.data.dados[0].VENDA);
                        console.log(response);
                    } else {
                        setCodProduto("");
                        setDescricao("");
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        [item]
    );

    function aplicaPrecoSugerido() {
        setVendaDefault(precoSugerido);
    }

    useEffect(() => {
        const regra = { 5: "1", 6: "2", 7: "3" };

        if (!cfop || cfop.length === 0) {
            return;
        }

        const primeiroDigito = cfop[0];
        const novoDigito = regra[primeiroDigito] || primeiroDigito;
        const novoCfop = novoDigito + cfop.slice(1);

        setCfop(novoCfop);
    }, [cfop]);

    useEffect(() => {
        const cstMap = {
            1: 50,
            2: 50,
            3: 50,
            4: 50,
            5: 50,
            6: 50,
            7: 70,
            8: 74,
            9: 72,
            49: 99,
        };

        const pisCst = formData?.IMPOSTOS?.PIS?.CST;
        const cofinsCst = formData?.IMPOSTOS?.COFINS?.CST;


        if (pisCst in cstMap || cofinsCst in cstMap) {
            setFormData((prev) => {
                const updated = { ...prev };

                if (pisCst in cstMap) {
                    updated.IMPOSTOS = {
                        ...updated.IMPOSTOS,
                        PIS: {
                            ...updated.IMPOSTOS?.PIS,
                            CST: cstMap[pisCst],
                        },
                    };
                }

                if (cofinsCst in cstMap) {
                    updated.IMPOSTOS = {
                        ...updated.IMPOSTOS,
                        COFINS: {
                            ...updated.IMPOSTOS?.COFINS,
                            CST: cstMap[cofinsCst],
                        },
                    };
                }

                return updated;
            });
        }


    }, [formData.EAN]);

    useEffect(() => {
        const tooltipTriggerList = [].slice.call(
            document.querySelectorAll('[data-bs-toggle="tooltip"]')
        );
        tooltipTriggerList.forEach((el) => new window.bootstrap.Tooltip(el));
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;

        const keys = name.split(".");
        setFormData((prev) => {
            const newFormData = { ...prev };
            let current = newFormData;

            for (let i = 0; i < keys.length - 1; i++) {
                if (!current[keys[i]]) {
                    current[keys[i]] = {};
                }
                current = current[keys[i]];
            }

            current[keys[keys.length - 1]] = value;
            return newFormData;
        });
    };

    // Validadores CFOP e CST ICMS

    useEffect(() => {
        if(Number(cfop) === 1910){
            setFormData((prev) => ({
                ...prev,
                IMPOSTOS: {
                    ...prev.IMPOSTOS,
                    PIS:{
                        ...prev.IMPOSTOS?.PIS,
                        CST: 49,
                        vBC: 0,
                        pPIS: 0,
                        vPIS: 0,
                    },
                    COFINS:{
                        ...prev.IMPOSTOS?.COFINS,
                        CST: 49,
                        vBC: 0,
                        pCOFINS: 0,
                        vCOFINS: 0,
                    }
                }
            }))
        }
    },[cfop])

    useEffect(() => {
        if (Number(cfop) === 1102 && ![0, 20, 40, 41, 49].includes(Number(formData?.IMPOSTOS?.ICMS?.CST))) {
            setTextoCstIcms("CFOP 1102 permite apenas os CST 0, 20, 40, 41 e 49 para ICMS");
            setValorIncompativel(true);
        }else{
            setTextoCstIcms('');
            setValorIncompativel(false);
        }
    },[cfop, formData?.IMPOSTOS?.ICMS?.CST])

    useEffect(() => {
        if ([1403, 1405].includes(Number(cfop)) && ![10, 60].includes(Number(formData?.IMPOSTOS?.ICMS?.CST))) {
            setTextoCstIcms("CFOP 1403 ou 1405 permite apenas os CST 10, 60 para ICMS");
            setValorIncompativel(true);
        }else{
            setTextoCstIcms('');
            setValorIncompativel(false);
        }
    },[cfop, formData?.IMPOSTOS?.ICMS?.CST])

    const handleSubmit = (e) => {
        e.preventDefault();
        const updatedFormData = {
            ...formData,
            COMPRA: precoRealCompra,
            PRECO_ATUAL_VENDA: vendaDefault,
        };
        onSave(updatedFormData);
    };

    return (
        <Modal show={show} onHide={handleClose} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>Editar Item</Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                    <Row>
                        <Col md={2}>
                            <Form.Group className="mb-3">
                                <Form.Label>EAN</Form.Label>
                                <br />
                                <Form.Label
                                    className="text-primary"
                                    data-bs-toggle="tooltip"
                                    title="Informações em azul são referentes a nota."
                                >
                                    {formData?.EAN}
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    name="EAN"
                                    value={codProduto || ""}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Descrição</Form.Label>
                                <br />
                                <Form.Label
                                    className="text-primary"
                                    data-bs-toggle="tooltip"
                                    title="Informações em azul são referentes a nota."
                                >
                                    {formData?.DESCRICAO}
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    name="DESCRICAO"
                                    value={descricao || ""}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={1}>
                            <Form.Group className="mb-3">
                                <Form.Label>Unidade</Form.Label>
                                <br />
                                <Form.Label
                                    className="text-primary"
                                    data-bs-toggle="tooltip"
                                    title="Informações em azul são referentes a nota."
                                >
                                    {formData?.UNIDADE}
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    name="UNIDADE"
                                    value={unidade || ""}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={2}>
                            <Form.Group className="mb-3">
                                <Form.Label>NCM</Form.Label>
                                <br />
                                <Form.Label
                                    className="text-primary"
                                    data-bs-toggle="tooltip"
                                    title="Informações em azul são referentes a nota."
                                >
                                    {formData?.NCM}
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    name="NCM"
                                    value={ncm || ""}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={2}>
                            <Form.Group className="mb-3">
                                <Form.Label>CEST</Form.Label>
                                <br />
                                <Form.Label
                                    className="text-primary"
                                    data-bs-toggle="tooltip"
                                    title="Informações em azul são referentes a nota."
                                >
                                    {formData.CEST}
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    name="CEST"
                                    value={cest || ""}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={2}>
                            <Form.Group className="mb-3">
                                <Form.Label>CFOP</Form.Label>
                                <br />
                                <Form.Label
                                    className="text-primary"
                                    data-bs-toggle="tooltip"
                                    title="Informações em azul são referentes a nota."
                                >
                                    {formData.CFOP}
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    name="CFOP"
                                    value={cfop || ""}
                                    onChange={(e) => setCfop(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={2}>
                            <Form.Group className="mb-3">
                                <Form.Label>Qtd Embalagem</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="RELACAO.QTD_FORNECEDOR"
                                    value={formData?.RELACAO.QTD_FORNECEDOR || 0}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={2}>
                            <Form.Group className="mb-3">
                                <Form.Label>Qtd Pedida</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="QTD"
                                    value={formData?.QTD || 0}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={2}>
                            <Form.Group className="mb-3">
                                <Form.Label>Qtd Unitizada</Form.Label>
                                <Form.Control
                                    type="text"
                                    disabled
                                    value={qtdUnitizada}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={2}>
                            <Form.Group className="mb-3">
                                <Form.Label>Preço Unitário</Form.Label>
                                <NumericFormat
                                    customInput={Form.Control}
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    prefix="R$ "
                                    name="precoUnitario"
                                    value={precoUnitario ? precoUnitario : 0}
                                    onChange={(e) => (e.target.value)}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    allowNegative={false}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={2}>
                            <Form.Group className="mb-3">
                                <Form.Label>Valor Compra</Form.Label>
                                <NumericFormat
                                    customInput={Form.Control}
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    prefix="R$ "
                                    name="COMPRA"
                                    value={formData?.COMPRA || 0}
                                    onValueChange={(values) => {
                                        const { floatValue } = values;
                                        setFormData((prev) => ({
                                            ...prev,
                                            COMPRA: floatValue,
                                        }));
                                    }}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    allowNegative={false}
                                />
                            </Form.Group>
                        </Col>




                        <Col md={2}>
                            <Form.Group className="mb-3">
                                <Form.Label>Total</Form.Label>
                                <NumericFormat
                                    customInput={Form.Control}
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    prefix="R$ "
                                    name="TOTAL"
                                    value={formData?.TOTAL || 0}
                                    onValueChange={(values) => {
                                        const { floatValue } = values;
                                        setFormData((prev) => ({
                                            ...prev,
                                            TOTAL: floatValue,
                                        }));
                                    }}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    allowNegative={false}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <hr />

                    <h6>ICMS</h6>
                    <Row>
                        <Col md={2}>
                            <Form.Group className="mb-3">
                                <Form.Label>CST ICMS</Form.Label>
                                <InputGroup>
                                    <NumericFormat
                                        customInput={Form.Control}
                                        thousandSeparator="."
                                        decimalSeparator=","
                                        name="IMPOSTOS.ICMS.CST"
                                        value={formData?.IMPOSTOS?.ICMS?.CST || 0}
                                        onValueChange={(values) => {
                                            const { floatValue } = values;
                                            setFormData((prev) => ({
                                                ...prev,
                                                IMPOSTOS: {
                                                    ...prev.IMPOSTOS,
                                                    ICMS: {
                                                        ...prev.IMPOSTOS?.ICMS,
                                                        CST: floatValue,
                                                    },
                                                },
                                            }));
                                        }}
                                        decimalScale={0}
                                        fixedDecimalScale
                                        allowNegative={false}
                                    />
                                    {vlrIncompativel && (
                                        <InputGroup.Text className="bg-white">
                                            <i
                                                className="bi-exclamation-circle-fill text-danger"
                                                title={textoCstIcms}
                                                data-bs-toggle="tooltip"
                                            ></i>
                                        </InputGroup.Text>
                                    )}
                                </InputGroup>
                            </Form.Group>
                        </Col>

                        <Col md={2}>
                            <Form.Group className="mb-3">
                                <Form.Label>Red. Base Cálculo</Form.Label>
                                <NumericFormat
                                    customInput={Form.Control}
                                    suffix="%"
                                    decimalSeparator=","
                                    name="IMPOSTOS.ICMS.pRedBCST"
                                    value={formData?.IMPOSTOS?.ICMS?.pRedBCST || 0}
                                    onValueChange={(values) => {
                                        const { floatValue } = values;
                                        setFormData((prev) => ({
                                            ...prev,
                                            IMPOSTOS: {
                                                ...prev.IMPOSTOS,
                                                ICMS: {
                                                    ...prev.IMPOSTOS?.ICMS,
                                                    pRedBCST: floatValue,
                                                },
                                            },
                                        }));
                                    }}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    allowNegative={false}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={2}>
                            <Form.Group className="mb-3">
                                <Form.Label>Base de Cálculo ICMS</Form.Label>
                                <NumericFormat
                                    customInput={Form.Control}
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    prefix="R$ "
                                    name="IMPOSTOS.ICMS.vBC"
                                    value={formData?.IMPOSTOS?.ICMS?.vBC || 0}
                                    onValueChange={(values) => {
                                        const { floatValue } = values;
                                        setFormData((prev) => ({
                                            ...prev,
                                            IMPOSTOS: {
                                                ...prev.IMPOSTOS,
                                                ICMS: {
                                                    ...prev.IMPOSTOS?.ICMS,
                                                    vBC: floatValue,
                                                },
                                            },
                                        }));
                                    }}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    allowNegative={false}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={2}>
                            <Form.Group className="mb-3">
                                <Form.Label>Alíquota ICMS (%)</Form.Label>
                                <NumericFormat
                                    customInput={Form.Control}
                                    suffix="%"
                                    decimalSeparator=","
                                    name="IMPOSTOS.ICMS.pICMS"
                                    value={formData?.IMPOSTOS?.ICMS?.pICMS || 0}
                                    onValueChange={(values) => {
                                        const { floatValue } = values;
                                        setFormData((prev) => ({
                                            ...prev,
                                            IMPOSTOS: {
                                                ...prev.IMPOSTOS,
                                                ICMS: {
                                                    ...prev.IMPOSTOS?.ICMS,
                                                    pICMS: floatValue,
                                                },
                                            },
                                        }));
                                    }}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    allowNegative={false}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={2}>
                            <Form.Group className="mb-3">
                                <Form.Label>Valor ICMS</Form.Label>
                                <NumericFormat
                                    customInput={Form.Control}
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    prefix="R$ "
                                    name="IMPOSTOS.ICMS.vBC"
                                    value={formData?.IMPOSTOS?.ICMS?.vICMS || 0}
                                    onValueChange={(values) => {
                                        const { floatValue } = values;
                                        setFormData((prev) => ({
                                            ...prev,
                                            IMPOSTOS: {
                                                ...prev.IMPOSTOS,
                                                ICMS: {
                                                    ...prev.IMPOSTOS?.ICMS,
                                                    vICMS: floatValue,
                                                },
                                            },
                                        }));
                                    }}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    allowNegative={false}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={2}></Col>

                        <Col md={2}>
                            <Form.Group className="mb-3">
                                <Form.Label>Base de Cálculo FCP</Form.Label>
                                <NumericFormat
                                    customInput={Form.Control}
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    prefix="R$ "
                                    name="IMPOSTOS.ICMS.vBCFCP"
                                    value={formData?.IMPOSTOS?.ICMS?.vBCFCP || 0}
                                    onValueChange={(values) => {
                                        const { floatValue } = values;
                                        setFormData((prev) => ({
                                            ...prev,
                                            IMPOSTOS: {
                                                ...prev.IMPOSTOS,
                                                ICMS: {
                                                    ...prev.IMPOSTOS?.ICMS,
                                                    vBCFCP: floatValue,
                                                },
                                            },
                                        }));
                                    }}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    allowNegative={false}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={2}>
                            <Form.Group className="mb-3">
                                <Form.Label>Perc. FCP</Form.Label>
                                <NumericFormat
                                    customInput={Form.Control}
                                    suffix="%"
                                    decimalSeparator=","
                                    name="IMPOSTOS.ICMS.pFCP"
                                    value={formData?.IMPOSTOS?.ICMS?.pFCP || 0}
                                    onValueChange={(values) => {
                                        const { floatValue } = values;
                                        setFormData((prev) => ({
                                            ...prev,
                                            IMPOSTOS: {
                                                ...prev.IMPOSTOS,
                                                ICMS: {
                                                    ...prev.IMPOSTOS?.ICMS,
                                                    pFCP: floatValue,
                                                },
                                            },
                                        }));
                                    }}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    allowNegative={false}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={2}>
                            <Form.Group className="mb-3">
                                <Form.Label>Valor FCP</Form.Label>
                                <NumericFormat
                                    customInput={Form.Control}
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    prefix="R$ "
                                    name="IMPOSTOS.ICMS.vFPC"
                                    value={formData?.IMPOSTOS?.ICMS?.vFCP || 0}
                                    onValueChange={(values) => {
                                        const { floatValue } = values;
                                        setFormData((prev) => ({
                                            ...prev,
                                            IMPOSTOS: {
                                                ...prev.IMPOSTOS,
                                                ICMS: {
                                                    ...prev.IMPOSTOS?.ICMS,
                                                    vFCP: floatValue,
                                                },
                                            },
                                        }));
                                    }}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    allowNegative={false}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <hr />

                    <Row>
                        <h6>Imposto de Subst Tributária</h6>

                        <Col md={2}>
                            <Form.Group className="mb-3">
                                <Form.Label>MVA ST</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="IMPOSTOS.ICMS.pMVAST"
                                    value={formData?.IMPOSTOS?.ICMS?.pMVAST || 0}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={2}>
                            <Form.Group className="mb-3">
                                <Form.Label>Valor ICMS Base Subst.</Form.Label>
                                <NumericFormat
                                    customInput={Form.Control}
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    prefix="R$ "
                                    name="IMPOSTOS.ICMS.vBCST"
                                    value={formData?.IMPOSTOS?.ICMS?.vBCST || 0}
                                    onValueChange={(values) => {
                                        const { floatValue } = values;
                                        setFormData((prev) => ({
                                            ...prev,
                                            IMPOSTOS: {
                                                ...prev.IMPOSTOS,
                                                ICMS: {
                                                    ...prev.IMPOSTOS?.ICMS,
                                                    vBCST: floatValue,
                                                },
                                            },
                                        }));
                                    }}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    allowNegative={false}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={2}>
                            <Form.Group className="mb-3">
                                <Form.Label>Aliq. ICMS Subst.</Form.Label>
                                <NumericFormat
                                    customInput={Form.Control}
                                    suffix="%"
                                    decimalSeparator=","
                                    name="IMPOSTOS.ICMS.pICMSST"
                                    value={formData?.IMPOSTOS?.ICMS?.pICMSST || 0}
                                    onValueChange={(values) => {
                                        const { floatValue } = values;
                                        setFormData((prev) => ({
                                            ...prev,
                                            IMPOSTOS: {
                                                ...prev.IMPOSTOS,
                                                ICMS: {
                                                    ...prev.IMPOSTOS?.ICMS,
                                                    pICMSST: floatValue,
                                                },
                                            },
                                        }));
                                    }}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    allowNegative={false}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={2}>
                            <Form.Group className="mb-3">
                                <Form.Label>Valor ST</Form.Label>
                                <NumericFormat
                                    customInput={Form.Control}
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    prefix="R$ "
                                    name="IMPOSTOS.ICMS.vICMSST"
                                    value={formData?.IMPOSTOS?.ICMS?.vICMSST || 0}
                                    onValueChange={(values) => {
                                        const { floatValue } = values;
                                        setFormData((prev) => ({
                                            ...prev,
                                            IMPOSTOS: {
                                                ...prev.IMPOSTOS,
                                                ICMS: {
                                                    ...prev.IMPOSTOS?.ICMS,
                                                    vICMSST: floatValue,
                                                },
                                            },
                                        }));
                                    }}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    allowNegative={false}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={2}></Col>
                        <Col md={2}>
                            <Form.Group className="mb-3">
                                <Form.Label>BC FCP ST</Form.Label>
                                <NumericFormat
                                    customInput={Form.Control}
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    prefix="R$ "
                                    name="IMPOSTOS.ICMS.vBCFCPST"
                                    value={formData?.IMPOSTOS?.ICMS?.vBCFCPST || 0}
                                    onValueChange={(values) => {
                                        const { floatValue } = values;
                                        setFormData((prev) => ({
                                            ...prev,
                                            IMPOSTOS: {
                                                ...prev.IMPOSTOS,
                                                ICMS: {
                                                    ...prev.IMPOSTOS?.ICMS,
                                                    vBCFCPST: floatValue,
                                                },
                                            },
                                        }));
                                    }}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    allowNegative={false}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={2}>
                            <Form.Group className="mb-3">
                                <Form.Label>Perc. FCP ST</Form.Label>
                                <NumericFormat
                                    customInput={Form.Control}
                                    suffix="%"
                                    decimalSeparator=","
                                    name="IMPOSTOS.ICMS.pFCPST"
                                    value={formData?.IMPOSTOS?.ICMS?.pFCPST || 0}
                                    onValueChange={(values) => {
                                        const { floatValue } = values;
                                        setFormData((prev) => ({
                                            ...prev,
                                            IMPOSTOS: {
                                                ...prev.IMPOSTOS,
                                                ICMS: {
                                                    ...prev.IMPOSTOS?.ICMS,
                                                    pFCPST: floatValue,
                                                },
                                            },
                                        }));
                                    }}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    allowNegative={false}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={2}>
                            <Form.Group className="mb-3">
                                <Form.Label>Valor FCP ST</Form.Label>
                                <NumericFormat
                                    customInput={Form.Control}
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    prefix="R$ "
                                    name="IMPOSTOS.ICMS.vFPCST"
                                    value={formData?.IMPOSTOS?.ICMS?.vFCPST || 0}
                                    onValueChange={(values) => {
                                        const { floatValue } = values;
                                        setFormData((prev) => ({
                                            ...prev,
                                            IMPOSTOS: {
                                                ...prev.IMPOSTOS,
                                                ICMS: {
                                                    ...prev.IMPOSTOS?.ICMS,
                                                    vFCPST: floatValue,
                                                },
                                            },
                                        }));
                                    }}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    allowNegative={false}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <hr />

                    <h6>IPI</h6>
                    <Row>
                        <Col md={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>CST IPI</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="IMPOSTOS.IPI.IPI.CST"
                                    value={formData?.IMPOSTOS?.IPI?.IPI?.CST || 0}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Base de Cálculo IPI</Form.Label>
                                <NumericFormat
                                    customInput={Form.Control}
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    prefix="R$ "
                                    name="IMPOSTOS.IPI.IPI.vBC"
                                    value={formData?.IMPOSTOS?.IPI?.IPI?.vBC || 0}
                                    onValueChange={(values) => {
                                        const { floatValue } = values;
                                        setFormData((prev) => ({
                                            ...prev,
                                            IMPOSTOS: {
                                                ...prev.IMPOSTOS,
                                                IPI: {
                                                    ...prev.IMPOSTOS?.IPI,
                                                    IPI: {
                                                        ...prev.IMPOSTOS?.IPI.IPI,
                                                        vBC: floatValue,
                                                    },
                                                },

                                            },
                                        }));
                                    }}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    allowNegative={false}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Aliquota IPI</Form.Label>
                                <NumericFormat
                                    customInput={Form.Control}
                                    suffix="%"
                                    decimalSeparator=","
                                    name="IMPOSTOS.IPI.IPI.pIPI"
                                    value={formData?.IMPOSTOS?.IPI?.IPI?.pIPI || 0}
                                    onValueChange={(values) => {
                                        const { floatValue } = values;
                                        setFormData((prev) => ({
                                            ...prev,
                                            IMPOSTOS: {
                                                ...prev.IMPOSTOS,
                                                IPI: {
                                                    ...prev.IMPOSTOS?.IPI,
                                                    IPI: {
                                                        ...prev.IMPOSTOS?.IPI.IPI,
                                                        pIPI: floatValue,
                                                    },
                                                },

                                            },
                                        }));
                                    }}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    allowNegative={false}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Valor IPI</Form.Label>
                                <NumericFormat
                                    customInput={Form.Control}
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    prefix="R$ "
                                    name="IMPOSTOS.IPI.IPI.vBC"
                                    value={formData?.IMPOSTOS?.IPI?.IPI?.vIPI || 0}
                                    onValueChange={(values) => {
                                        const { floatValue } = values;
                                        setFormData((prev) => ({
                                            ...prev,
                                            IMPOSTOS: {
                                                ...prev.IMPOSTOS,
                                                IPI: {
                                                    ...prev.IMPOSTOS?.IPI,
                                                    IPI: {
                                                        ...prev.IMPOSTOS?.IPI.IPI,
                                                        vIPI: floatValue,
                                                    },
                                                },

                                            },
                                        }));
                                    }}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    allowNegative={false}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <hr />

                    <h6>PIS</h6>
                    <Row>
                        <Col md={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>CST PIS</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="IMPOSTOS.PIS.CST"
                                    value={formData?.IMPOSTOS?.PIS?.CST || 0}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Base de Cálculo PIS</Form.Label>
                                <NumericFormat
                                    customInput={Form.Control}
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    prefix="R$ "
                                    name="IMPOSTOS.PIS.vBC"
                                    value={formData?.IMPOSTOS?.PIS?.vBC || 0}
                                    onValueChange={(values) => {
                                        const { floatValue } = values;
                                        setFormData((prev) => ({
                                            ...prev,
                                            IMPOSTOS: {
                                                ...prev.IMPOSTOS,
                                                PIS: {
                                                    ...prev.IMPOSTOS?.PIS,
                                                    vBC: floatValue,
                                                },
                                            },
                                        }));
                                    }}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    allowNegative={false}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Aliquota PIS</Form.Label>
                                <NumericFormat
                                    customInput={Form.Control}
                                    suffix="%"
                                    decimalSeparator=","
                                    name="IMPOSTOS.PIS.pPIS"
                                    value={formData?.IMPOSTOS?.PIS?.pPIS || 0}
                                    onValueChange={(values) => {
                                        const { floatValue } = values;
                                        setFormData((prev) => ({
                                            ...prev,
                                            IMPOSTOS: {
                                                ...prev.IMPOSTOS,
                                                PIS: {
                                                    ...prev.IMPOSTOS?.PIS,
                                                    pPIS: floatValue,
                                                },
                                            },
                                        }));
                                    }}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    allowNegative={false}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Valor PIS</Form.Label>
                                <NumericFormat
                                    customInput={Form.Control}
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    prefix="R$ "
                                    name="IMPOSTOS.PIS.vPIS"
                                    value={formData?.IMPOSTOS?.PIS?.vPIS || 0}
                                    onValueChange={(values) => {
                                        const { floatValue } = values;
                                        setFormData((prev) => ({
                                            ...prev,
                                            IMPOSTOS: {
                                                ...prev.IMPOSTOS,
                                                PIS: {
                                                    ...prev.IMPOSTOS?.PIS,
                                                    vPIS: floatValue,
                                                },
                                            },
                                        }));
                                    }}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    allowNegative={false}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <hr />
                    <h6>COFINS</h6>
                    <Row>
                        <Col md={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>CST COFINS</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="IMPOSTOS.COFINS.CST"
                                    value={formData?.IMPOSTOS?.COFINS?.CST || 0}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Base de Cálculo COFINS</Form.Label>
                                <NumericFormat
                                    customInput={Form.Control}
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    prefix="R$ "
                                    name="IMPOSTOS.COFINS.vBC"
                                    value={formData?.IMPOSTOS?.COFINS?.vBC || 0}
                                    onValueChange={(values) => {
                                        const { floatValue } = values;
                                        setFormData((prev) => ({
                                            ...prev,
                                            IMPOSTOS: {
                                                ...prev.IMPOSTOS,
                                                COFINS: {
                                                    ...prev.IMPOSTOS?.COFINS,
                                                    vBC: floatValue,
                                                },
                                            },
                                        }));
                                    }}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    allowNegative={false}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Aliquota COFINS</Form.Label>
                                <NumericFormat
                                    customInput={Form.Control}
                                    suffix="%"
                                    decimalSeparator=","
                                    name="IMPOSTOS.COFINS.pCOFINS"
                                    value={formData?.IMPOSTOS?.COFINS?.pCOFINS || 0}
                                    onValueChange={(values) => {
                                        const { floatValue } = values;
                                        setFormData((prev) => ({
                                            ...prev,
                                            IMPOSTOS: {
                                                ...prev.IMPOSTOS,
                                                COFINS: {
                                                    ...prev.IMPOSTOS?.COFINS,
                                                    pCOFINS: floatValue,
                                                },
                                            },
                                        }));
                                    }}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    allowNegative={false}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Valor COFINS</Form.Label>
                                <NumericFormat
                                    customInput={Form.Control}
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    prefix="R$ "
                                    name="IMPOSTOS.COFINS.vCOFINS"
                                    value={formData?.IMPOSTOS?.COFINS?.vCOFINS || 0}
                                    onValueChange={(values) => {
                                        const { floatValue } = values;
                                        setFormData((prev) => ({
                                            ...prev,
                                            IMPOSTOS: {
                                                ...prev.IMPOSTOS,
                                                COFINS: {
                                                    ...prev.IMPOSTOS?.COFINS,
                                                    vCOFINS: floatValue,
                                                },
                                            },
                                        }));
                                    }}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    allowNegative={false}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <hr />
                    <h6>Informação Comercial</h6>
                    <Row>
                        <Col md={2}>
                            <Form.Group className="mb-3">
                                <Form.Label>Preço Real Compra</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={precoRealCompra.toLocaleString("pt-br", {
                                        style: "currency",
                                        currency: "BRL",
                                    })}
                                    onChange={(e) => setPrecoRealCompra(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={2}>
                            <Form.Group className="mb-3">
                                <Form.Label>Markup</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={markup.toFixed(2) + "%"}
                                    onChange={(e) => setMarkup(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={2}>
                            <Form.Group className="mb-3">
                                <Form.Label>Preço Atual de Venda </Form.Label>
                                <Form.Control
                                    type="text"
                                    value={vendaDefault.toLocaleString("pt-br", {
                                        style: "currency",
                                        currency: "BRL",
                                    })}
                                    onChange={(e) => setVendaDefault(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={2}>
                            <Form.Group className="mb-3">
                                <Form.Label>Preço Sugerido</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={precoSugerido.toLocaleString("pt-br", {
                                        style: "currency",
                                        currency: "BRL",
                                    })}
                                    onChange={(e) => setPrecoSugerido(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={2}>
                            <Button
                                className="btn btn-primary mt-4"
                                onClick={aplicaPrecoSugerido}
                            >
                                <i className="bi-arrow-bar-left mr-1"></i>
                                Aplicar Preço
                            </Button>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handleSubmit}>
                        Salvar
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default ModalSaveItens;
